import ready from '../components/_ready';
import 'vanilla-cookieconsent/dist/cookieconsent.js'; // eslint-disable-line

let cc;

export default function cookies() {
  cc = window.initCookieConsent();
  const locale = document.documentElement.getAttribute('locale');
  const selectorDetails = document.querySelector('.js--cookie-data');
  if (!selectorDetails) return;
  const detail = JSON.parse(selectorDetails.getAttribute('data-cookie-detail'));
  const cookieName = selectorDetails.getAttribute('data-cookie-name');
  if (!detail) return;
  const days = selectorDetails.getAttribute('data-days');
  cc.run({
    current_lang: locale || 'pt',
    autoclear_cookies: true,
    page_scripts: true,
    cookie_name: cookieName,
    cookie_expiration: days,
    gui_options: {
      consent_modal: {
        layout: 'cloud',
        position: 'bottom center',
        transition: 'slide',
        swap_buttons: false,
      },
    },
    languages: detail,
  });
}

function cookiesChangeBtn() {
  const btn = document.querySelector('#cookies_btn');

  if (btn !== null) {
    btn.addEventListener('click', () => {
      cc.showSettings();
    });
  }
}

ready(() => {
  cookies();
  cookiesChangeBtn();
});
